import Vue from 'vue'
import Vuex from 'vuex'
import { svg } from './svg'
import * as actions from './actions'
import * as axios from "axios"

Vue.use(Vuex)

const evtSource = new EventSource('/api/events')

evtSource.onopen = (e) => {
  console.log(`SSE Connected`)
}
evtSource.onmessage = (e) => {
  /* dispatch action to render clients in the pub - add/remove */
  console.log(e.data)
  store.dispatch('get_zoom')
}
evtSource.onerror = (e) => {
  console.log(`SSE Err/Close`)
}

const store = new Vuex.Store({
  state: {
    svg,
    masa: undefined,
    tables: {
      bar: undefined,
      unu: undefined,
      doi: undefined,
      trei: undefined
    },
    isOpen: true,
    meetings: {},
    users: {
      'Open-Pub-bar': [],
      'Open-Pub-masa-unu': [],
      'Open-Pub-masa-doi': [],
      'Open-Pub-masa-trei': []
    }
  },

  mutations: {
    SET_KEY_VALUE (state, { key, value }) {
      Vue.set(state, key, value)
    }
   },

  actions: {
    get_zoom ({ state }) {
      getZoom()

      async function getZoom() {
        try {
          const { data } = await axios('/api/get-zoom')
          state.meetings = data.meetings
          state.users = data.users
        } catch (e) {
          console.log(`err get zoom: `, e.response.data)
        }
      }
    },

    get_sse_events ({ state }) {
      getSSE()

      async function getSSE() {
        try {
          const { data } = await axios('/api/events/')
          console.log(data)
        } catch (e) {
          console.log(e)
        }
      }
    },

    create_table ({ state }, user) {
      create()

      async function create() {
        try {
          const { data } = await axios.post('/api/create-table', user)
        } catch (e) {

        }
      }
    },
  }
})

export default store
